import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EPermission } from '../enums/permission.enum';
import { PrivilegeService } from '../services/privilege.service';

export const canCurateHelpGuard: CanActivateFn = async () => {
  const privilegeService = inject(PrivilegeService);
  const router = inject(Router);

  if (await privilegeService.hasPermission(EPermission.CurateHelpFeedback)) {
    return true;
  }

  await router.navigate(['/']);

  return false;
};
